import { Link } from "gatsby"
import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import logo from "../images/Cross-church-web.png"

const NavLink = styled(Link)`
  color: #f7fafc;
  font-size: 1.2rem;
  line-height: 2rem;
  text-decoration: none;
  font-family: "Montserrat";
  font-weight: 400;
  @media (max-width: 640px) {
    font-size: 1rem;
  }
`

const FooterHeader = styled.a`
  font-weight: 600;
  text-decoration: none;
  font-family: "Montserrat";
  color: #e2e8f0;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  letter-spacing: 1px;
  @media (max-width: 640px) {
    font-size: 1rem;
  }
`

const Footer = () => (
  <header
    css={css`
      background: #f07525;
      display: flex;
      justify-content: space-between;
      padding: 0.5rem calc((100vw - 1050px) / 2);
      height: 16rem;
      align-items: center;
      @media (max-width: 1050px) {
        padding: 2rem;
      }
      @media (max-width: 640px) {
        flex-direction: column;
        height: 28rem;
      }
    `}
  >
    <div
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
      `}
    >
      <img
        css={css`
          height: 3rem;
        `}
        src={logo}
        alt=""
      />
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          padding-top: 2rem;
        `}
      >
        <a href="https://www.facebook.com/crosschurchphx/">
          <svg
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            css={css`
              height: 22px;
              fill: #fff;
            `}
          >
            <path d="m75 512h167v-182h-60v-60h60v-75c0-41.355469 33.644531-75 75-75h75v60h-60c-16.542969 0-30 13.457031-30 30v60h87.292969l-10 60h-77.292969v182h135c41.355469 0 75-33.644531 75-75v-362c0-41.355469-33.644531-75-75-75h-362c-41.355469 0-75 33.644531-75 75v362c0 41.355469 33.644531 75 75 75zm-45-437c0-24.8125 20.1875-45 45-45h362c24.8125 0 45 20.1875 45 45v362c0 24.8125-20.1875 45-45 45h-105v-122h72.707031l20-120h-92.707031v-30h90v-120h-105c-57.898438 0-105 47.101562-105 105v45h-60v120h60v122h-137c-24.8125 0-45-20.1875-45-45zm0 0" />
          </svg>
        </a>
        <a href="https://www.instagram.com/crosschurchphx/">
          <svg
            viewBox="0 0 512 512"
            css={css`
              height: 22px;
              fill: #fff;
            `}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m75 512h362c41.355469 0 75-33.644531 75-75v-362c0-41.355469-33.644531-75-75-75h-362c-41.355469 0-75 33.644531-75 75v362c0 41.355469 33.644531 75 75 75zm-45-437c0-24.8125 20.1875-45 45-45h362c24.8125 0 45 20.1875 45 45v362c0 24.8125-20.1875 45-45 45h-362c-24.8125 0-45-20.1875-45-45zm0 0" />
            <path d="m256 391c74.4375 0 135-60.5625 135-135s-60.5625-135-135-135-135 60.5625-135 135 60.5625 135 135 135zm0-240c57.898438 0 105 47.101562 105 105s-47.101562 105-105 105-105-47.101562-105-105 47.101562-105 105-105zm0 0" />
            <path d="m406 151c24.8125 0 45-20.1875 45-45s-20.1875-45-45-45-45 20.1875-45 45 20.1875 45 45 45zm0-60c8.269531 0 15 6.730469 15 15s-6.730469 15-15 15-15-6.730469-15-15 6.730469-15 15-15zm0 0" />
          </svg>
        </a>
        <a href="https://twitter.com/crosschurchphx">
          <svg
            viewBox="0 -47 512.00004 512"
            css={css`
              height: 22px;
              fill: #fff;
            `}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m512 55.964844c-32.207031 1.484375-31.503906 1.363281-35.144531 1.667968l19.074219-54.472656s-59.539063 21.902344-74.632813 25.820313c-39.640625-35.628907-98.5625-37.203125-140.6875-11.3125-34.496094 21.207031-53.011719 57.625-46.835937 100.191406-67.136719-9.316406-123.703126-41.140625-168.363282-94.789063l-14.125-16.964843-10.554687 19.382812c-13.339844 24.492188-17.769531 52.496094-12.476563 78.851563 2.171875 10.8125 5.863282 21.125 10.976563 30.78125l-12.117188-4.695313-1.4375 20.246094c-1.457031 20.566406 5.390625 44.574219 18.320313 64.214844 3.640625 5.53125 8.328125 11.605469 14.269531 17.597656l-6.261719-.960937 7.640625 23.199218c10.042969 30.480469 30.902344 54.0625 57.972657 67.171875-27.035157 11.472657-48.875 18.792969-84.773438 30.601563l-32.84375 10.796875 30.335938 16.585937c11.566406 6.324219 52.4375 27.445313 92.820312 33.78125 89.765625 14.078125 190.832031 2.613282 258.871094-58.664062 57.308594-51.613282 76.113281-125.03125 72.207031-201.433594-.589844-11.566406 2.578125-22.605469 8.921875-31.078125 12.707031-16.964844 48.765625-66.40625 48.84375-66.519531zm-72.832031 48.550781c-10.535157 14.066406-15.8125 32.03125-14.867188 50.578125 3.941407 77.066406-17.027343 136.832031-62.328125 177.628906-52.917968 47.660156-138.273437 66.367188-234.171875 51.324219-17.367187-2.722656-35.316406-8.820313-50.171875-14.910156 30.097656-10.355469 53.339844-19.585938 90.875-37.351563l52.398438-24.800781-57.851563-3.703125c-27.710937-1.773438-50.785156-15.203125-64.96875-37.007812 7.53125-.4375 14.792969-1.65625 22.023438-3.671876l55.175781-15.367187-55.636719-13.625c-27.035156-6.621094-42.445312-22.796875-50.613281-35.203125-5.363281-8.152344-8.867188-16.503906-10.96875-24.203125 5.578125 1.496094 12.082031 2.5625 22.570312 3.601563l51.496094 5.09375-40.800781-31.828126c-29.398437-22.929687-41.179687-57.378906-32.542969-90.496093 91.75 95.164062 199.476563 88.011719 210.320313 90.527343-2.386719-23.183593-2.449219-23.238281-3.074219-25.445312-13.886719-49.089844 16.546875-74.015625 30.273438-82.453125 28.671874-17.621094 74.183593-20.277344 105.707031 8.753906 6.808593 6.265625 16.015625 8.730469 24.632812 6.589844 7.734375-1.921875 14.082031-3.957031 20.296875-6.171875l-12.9375 36.945312 16.515625.011719c-3.117187 4.179688-6.855469 9.183594-11.351562 15.183594zm0 0" />
          </svg>
        </a>
      </div>
    </div>
    <nav
      css={css`
        display: flex;
        flex-direction: row;
      `}
    >
      <ul
        css={css`
          @media (max-width: 640px) {
            padding-inline-start: 0px;
          }
        `}
      >
        <li
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <FooterHeader>ABOUT US</FooterHeader>
          <NavLink to="/whoweare">Who We Are</NavLink>
          <NavLink to="/phoenix/leadership">Our Leadership</NavLink>
          <NavLink to="/mission-and-vision">Our Mission and Vision</NavLink>
          <NavLink to="/beliefs">Statement of Faith</NavLink>
        </li>
      </ul>
      <ul>
        <li
          css={css`
            display: flex;
            flex-direction: column;
            margin-left: 2rem;
          `}
        >
          <FooterHeader>NEW TO CROSS?</FooterHeader>
          <NavLink to="/whattoexpect">What to Expect</NavLink>
          <NavLink to="/">Our Locations</NavLink>
          <NavLink to="/phoenix/connect">Connect with Us</NavLink>
          <NavLink to="/phoenix/visit">Schedule a Visit</NavLink>
        </li>
      </ul>
    </nav>
  </header>
)

export default Footer
